// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//window.Vue = require('vue');
import moment from 'moment';

import Vue from 'vue';
import App from './App';
import router from './router';

import axios from 'axios';
import VueAxios from 'vue-axios';

import nb_NO from 'vee-validate/dist/locale/nb_NO';
import VeeValidate, { Validator } from 'vee-validate';

import auth from '@websanova/vue-auth/dist/v2/vue-auth.esm.js';
import driverAuthBearer from '@websanova/vue-auth/dist/drivers/auth/bearer.esm.js';
import driverHttpAxios from '@websanova/vue-auth/dist/drivers/http/axios.1.x.esm.js';
import driverRouterVueRouter from '@websanova/vue-auth/dist/drivers/router/vue-router.2.x.esm.js';

import { config } from '../volunteer/config/config';

moment.locale(config.localeApp);
if (config.localeApp == 'se') {
    document.title = 'SOS dieđáhus';
}

Vue.use(VeeValidate);
Validator.localize('nb_NO', nb_NO);

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);

if (window.location.hostname == 'localhost') {
    Vue.axios.defaults.baseURL = 'https://services.kirkens-sos.lndo.site/api';
} else {
    Vue.axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + '/api';
}

Vue.router = router;

Vue.use(auth, {
    plugins: {
        http: Vue.axios,
        router: Vue.router,
    },
    drivers: {
        auth: driverAuthBearer,
        http: driverHttpAxios,
        router: driverRouterVueRouter,
    },
    options: {
        rolesKey: 'role',
        loginData: { url: 'caller/login' },
        fetchData: { url: 'caller/me', method: 'GET', enabled: true },
        refreshData: { url: 'caller/refresh', method: 'GET', enabled: true, interval: 30 },
        tokenDefaultName: 'sosmessages',
        stores: ['cookie'],
        cookie: {
            Path: '/',
            Domain: null,
            Secure: true,
            Expires: 12096e5,
            SameSite: 'None',
        },
    },
});

new Vue({
    el: '#app',
    components: { App },
    template: '<App/>',
    router,
});



// WEBPACK FOOTER //
// ./src/main.js